// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__MwWvM","headerHidden":"Header_headerHidden__4NKmH","headerError":"Header_headerError__x3J2o"};